import styled from 'styled-components';

import Button from '@rewardopl/react-ui/button';

export const RewardAndButtonWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const Reward = styled.div`
  width: 112px;
  min-height: 96px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  background: none;
  border: 0;
  padding: 0;
  color: inherit;
  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

export const ImageWrapper = styled.div`
  width: 70px;
  height: 70px;
  position: relative;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ImagePlaceholder = styled.img`
  width: 70px;
  height: 70px;
  object-fit: contain;
`;

export const CheckWrapper = styled.div`
  width: 28px;
  height: 28px;
  position: absolute;
  top: 0;
  right: 0;
  padding: 2px;
  background: #1f7d6b;
  border-radius: var(--border-radius-round);
  color: var(--white);
`;

export const Name = styled.p`
  flex-grow: 1;
  margin: 0;
  font-family: Butler, serif;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  text-transform: lowercase;
`;

export const WideButton = styled(Button)`
  width: 100%;
`;
